/**
 * Task 35: Candidate Form Modal Wrapper
 * Provides modal overlay for CandidateForm component
 */

import React from 'react';
import CandidateForm from '../shared/CandidateForm';

const CandidateFormModal = ({
  isOpen,
  onClose,
  onSuccess,
  prefilledJdId = null,
  mode = 'create',
  initialCandidate = null
}) => {
  if (!isOpen) return null;

  const handleSuccess = (candidate) => {
    if (onSuccess) {
      onSuccess(candidate);
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <CandidateForm
          onSuccess={handleSuccess}
          onCancel={onClose}
          prefilledJdId={prefilledJdId}
          mode={mode}
          initialCandidate={initialCandidate}
        />
      </div>
    </div>
  );
};

export default CandidateFormModal;
